// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import {withRouter, NavLink} from 'react-router-dom'
import {connect} from 'react-redux'

import ChangePassword from '../ChangePassword'
import Modal from '../Modal'
import ToggleContent from '../Toggle'

import {logout} from '../../actions/user'
import CustomDropdown from '../DropDown'

import config, {FETAURE_USER_MANAGEMENT_PRODUCTS, FEATURE_USER_MANAGEMENT_PROFILES, FEATURE_MY_PROFILE} from '../../config'

import PermIdentityIcon from '@material-ui/icons/PermIdentity'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined'

import {AdminIconComponent} from '../../media/icons/UserIconsComponent'

import {isAdmin} from '../../utils/user'

import './index.css'

const profiles_flag = config[FEATURE_USER_MANAGEMENT_PROFILES]
const products_flag = config[FETAURE_USER_MANAGEMENT_PRODUCTS]
const my_profile_flag = config[FEATURE_MY_PROFILE]

export class GlobalHeader extends React.Component {
  getUserIcon = (user_data) => {
    let role = user_data['custom:Role'] === 'TenantAdmin' ? 'Admin' : 'User'
    let name = user_data.given_name
    let last_name = user_data.family_name

    let icons = {
      'Admin': <AdminIconComponent color={'white'} />,
      'User': <PermIdentityIcon/>
    }

    return (
      <div className='user pull-right'>
        {icons[role]}&nbsp;{`${name} ${last_name}`} - <b>{role}</b>
      </div>
    )
  }

  render () {
    const {session, logout} = this.props
    const {user_data} = session

    return (
      <div className='global-header'>
        <div className='container-fluid'>
          <div className='col-12'>
            {session.user_data &&
                <CustomDropdown dropdownTrigger={this.getUserIcon(user_data)} className='col-md-2 col-3'>
                  <ul>
                    { my_profile_flag && (<li>
                      <NavLink to='/my-profile/'><AccountCircleOutlinedIcon/>&nbsp; My Profile</NavLink>
                    </li>)}
                    <li>
                      <ToggleContent
                        toggle={show => <a href='/#' onClick={(e) => {show(); e.preventDefault()}}><ExitToAppIcon/>&nbsp; Change My Password</a>}
                        content={hide => (
                          <Modal onHide={hide}>
                            <ChangePassword onHide={hide}/>
                          </Modal>
                        )}
                      />
                    </li>
                    {(products_flag || profiles_flag) && (isAdmin(user_data)) && (<li>
                      <NavLink to='/user-management/'><SupervisorAccountOutlinedIcon/>&nbsp; User management</NavLink>
                    </li>)}
                    <li id='sign-out-container'>
                      <a href='/#' onClick={logout}><EditOutlinedIcon/>&nbsp; Sign Out</a>
                    </li>
                  </ul>
                </CustomDropdown>
            }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps ({session}) {
  return {session}
}

export default withRouter(connect(mapStateToProps, {logout})(GlobalHeader))
